import React, { useEffect, useState } from "react";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import StudentIdCard1 from "../components/StudentIdCard1";
import { batchDetailsWithStudents, batchList } from "../../api/Batch";
import { printImg } from "../master/Print";
import StudentIdCard2 from "../components/StudentIdCard2";
import IdCardLayout from "./IdCardLayout";
import StudentIdCard3 from "../components/StudentIdCard3";
import StudentIdCard4 from "../components/StudentIdCard4";
import StudentIdCard5 from "../components/StudentIdCard5";
import { printIdCards } from "../master/PrintIdCards";
import usePrivateLink from "../config/usePrivateLink";

export default function StudentIdCard() {
  const hasAccess = usePrivateLink();

  const [loading, setLoading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [batchData, setBatchData] = useState({});
  const [students, setStudents] = useState([]);
  const [template, setTemplate] = useState("");
  const [sessions, setSessions] = useState([]);
  const [filters, setFilters] = useState({});
  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");

    setSessions(parseSessions);

    setFilters({
      session_id: parseSessions?.find((s) => s.status === "1")?.id,
    });
  }, []);

  const templates = [
    { id: "1", name: "IdCard 1", component: StudentIdCard1 },
    { id: "2", name: "IdCard 2", component: StudentIdCard2 },
    { id: "3", name: "IdCard 3", component: StudentIdCard3 },
    { id: "4", name: "IdCard 4", component: StudentIdCard4 },
    { id: "5", name: "IdCard 5 (Portrait)", component: StudentIdCard5 },
  ];

  const getBatchList = async () => {
    setLoading(true);
    try {
      const response = await batchList();
      if (response.data.status) {
        setBatches(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchInfo = async (id) => {
    setLoading(true);
    try {
      let addUrl = `&id=${id}&status=1`;
      const response = await batchDetailsWithStudents(addUrl);
      if (response.data.status) {
        setBatchData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatchList();
  }, []);

  const handlePortraitPrint = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const styles = Array.from(
      document.querySelectorAll('link[rel="stylesheet"], style'),
    )
      .map((n) => n.outerHTML)
      .join("");

    const w = window.open("", "_blank");
    if (!w) return alert("Popup blocked!");

    w.document.write(`
    <html>
      <head>
        <title>Print ID Card</title>
        ${styles}
        <style>
          @page { size: 90mm 128mm; margin: 0; }
          body { margin: 0; }
          #PrintDiv { display: block !important; width: 90mm !important; padding: 0 !important; }
          .id5-card { page-break-after: always; break-after: page; margin: 0 !important; }
        </style>
      </head>
      <body>${el.outerHTML}</body>
    </html>
  `);
    w.document.close();
    w.onload = () =>
      setTimeout(() => {
        w.print();
        w.close();
      }, 500);
  };

  const handleBarCodePrint = async (id) => {
    setLoading(true);
    const invoiceElement = document.getElementById(id);
    if (!invoiceElement) return;
    const content = invoiceElement.outerHTML;
    const printWindow = window.open("", "_blank");

    if (!printWindow) {
      alert("Popup blocked!");
      return;
    }

    printWindow.document.write(`
      <html>
        <head>
       <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
          <title>Print Barcode</title>
          <style>
            @page { size: 95mm 65mm; margin: 0; }
            body { margin: 0; }
            .a4-page-horizontal-1 {
  width: 95mm !important;
  height: 65mm !important;
  border: 2pt solid rgba(255, 0, 0, 0.688) !important;
  border-radius: 10px;
  position: relative;
  z-index: 1;
}

.a4-page-horizontal-1 .institute-details {
  font-size: 8px;
  font-weight: bold;
  color: black;
  text-wrap: nowrap;
}

.a4-page-horizontal-1 .institute-details h6 {
  font-weight: 900 !important;
  color: rgba(255, 0, 0) !important;
  font-size: 22px;
}

.a4-page-horizontal-1 div {
  font-size: 10px;
  color: black;
  font-weight: bold;
}
.a4-page-horizontal-1 .address {
  font-size: 8px;
  color: black;
  font-weight: bold;
}

.a4-page-horizontal-1 .col-1 {
  width: 2% !important;
}

.a4-page-horizontal-1 .border {
  border: 1pt solid rgba(255, 0, 0, 0.688) !important;
}

.a4-page-horizontal-1 .border-top {
  border-top: 1pt solid rgba(255, 0, 0, 0.688) !important;
}

.a4-page-horizontal-1 .profile-img {
  width: 80px !important;
  height: 100px !important;
  content: cover;
  object-fit: cover;
}

.a4-page-horizontal-1::before {
  content: "";
  position: absolute;
  inset: 0;
  background-repeat: no-repeat;
  background-position: 30% center;
  background-size: 150px;
  opacity: 0.4;
  z-index: -1;
}

.a4-page-horizontal-1 .admission-date {
  position: absolute;
  right: 5px;
  top: 85%;
  transform: rotate(90deg) translateY(-50%);
  transform-origin: right top;
  font-size: 8px;
  font-weight: bold;
  white-space: nowrap;
}

.a4-page-horizontal-1 .signature {
  position: absolute;
  right: 12px;
  bottom: 1px;
  font-size: 8px;
  white-space: nowrap;

}

.a4-page-horizontal-1 .signature img {
  width: 80px !important;
}
  .a4-page-horizontal-1 .signature p {
  margin: 0  12px 6px 0 !important;  
}

          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 300);
    };
    // printWindow.focus();
    // printWindow.print();
    // printWindow.close();
    setLoading(false);
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <IdCardLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            <h4 className="text-primary m-0">
                              Student ID Card
                            </h4>
                            <hr />
                          </div>

                          <div className="col-4">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                name="batch_id"
                                onChange={(e) => {
                                  setBatchData([]);
                                  getBatchInfo(e.target.value);
                                }}
                              >
                                <option value="" selected disabled>
                                  Select Batch
                                </option>
                                {batches?.map((batch, i) => (
                                  <option key={i} value={batch?.id}>
                                    {batch?.title} ({batch?.course?.title})
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="batch_id">Select Batch</label>
                            </div>
                          </div>
                          {batchData?.active_batch_students && (
                            <div className="col-4">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="student_id"
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    if (value === "all") {
                                      setStudents(
                                        batchData?.active_batch_students || [],
                                      );
                                    } else {
                                      setStudents(
                                        batchData?.active_batch_students?.filter(
                                          (student) =>
                                            student?.student_id ===
                                            Number(value),
                                        ) || [],
                                      );
                                    }
                                  }}
                                >
                                  <option value="" selected disabled>
                                    Select Student
                                  </option>
                                  <option value="all">All</option>
                                  {batchData?.active_batch_students?.map(
                                    (student, i) => (
                                      <option
                                        key={i}
                                        value={student?.student_id}
                                      >
                                        {student?.student_info?.name} (
                                        {student?.student_info?.registration_no}
                                        )
                                      </option>
                                    ),
                                  )}
                                </select>
                                <label htmlFor="student_id">
                                  Select Student
                                </label>
                              </div>
                            </div>
                          )}

                          {batchData?.active_batch_students && (
                            <div className="col-sm-3">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={template}
                                  onChange={(e) => setTemplate(e.target.value)}
                                >
                                  <option value="" disabled>
                                    Select Template
                                  </option>

                                  {templates.map((t) => (
                                    <option key={t.id} value={t.id}>
                                      {t.name}
                                    </option>
                                  ))}
                                </select>
                                <label htmlFor="template_name">
                                  Select Template
                                </label>
                              </div>
                            </div>
                          )}
                          <div className="col-3 mt-2">
                            <div className="col-3 mt-2">
                              {hasAccess("/card/certificate/print") && (
                                <button
                                  className="btn btn-primary"
                                  disabled={!template || students.length === 0}
                                  onClick={() => printIdCards("PrintDiv")}
                                >
                                  Print
                                </button>
                              )}
                            </div>
                          </div>

                          <div className="col-12">
                            <hr />
                          </div>
                          <div
                            className="col-12 a4-page d-flex flex-wrap justify-content-center align-content-center gap-3"
                            id="PrintDiv"
                          >
                            {students?.map((student, i) => {
                              const selected = templates.find(
                                (t) => t.id === template,
                              );

                              const Component = selected?.component;

                              if (!Component) return null;

                              return (
                                <Component
                                  key={i}
                                  data={student}
                                  batch={batchData}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
